<template>
    <div class="box ptoTotal">
        <div class="box-head">
            <div class="head-name">项目统计</div>
            <div class="head-num">
                <el-menu class="el-menu-demo" mode="horizontal" background-color="#001498" active-text-color="#ffffff" @select="selectFun">
                    <el-submenu index="1">
                        <template slot="title"><p @click="showStatus('')">项目总数 <span style="color:#36C635;margin-left:10px;">{{num.all}}</span></p></template>
                        <el-menu-item index="1-1" class="total-item">房建 <span style="color:#FFBC01;margin-left:10px;">{{num.sjfj.fj}}</span></el-menu-item>
                        <el-menu-item index="1-2" class="total-item">市政 <span style="color:#FFBC01;margin-left:10px;">{{num.sjfj.sj}}</span></el-menu-item>
                    </el-submenu>
                    <el-submenu index="2">
                        <template slot="title"><p @click="showStatus(2)">在建 <span style="color:#36C635;margin-left:10px;">{{num.zj.zjxm}}</span></p></template>
                        <el-menu-item index="2-1" class="total-item">房建 <span style="color:#FFBC01;margin-left:10px;">{{num.zj.zjfj}}</span></el-menu-item>
                        <el-menu-item index="2-2" class="total-item">市政 <span style="color:#FFBC01;margin-left:10px;">{{num.zj.zjsz}}</span></el-menu-item>
                    </el-submenu>
                    <el-submenu index="3">
                        <template slot="title"><p @click="showStatus(3)">竣工 <span style="color:#36C635;margin-left:10px;">{{num.jg.jgxm}}</span></p></template>
                        <el-menu-item index="3-1" class="total-item">房建 <span style="color:#FFBC01;margin-left:10px;">{{num.jg.jgfj}}</span></el-menu-item>
                        <el-menu-item index="3-2" class="total-item">市政 <span style="color:#FFBC01;margin-left:10px;">{{num.jg.jgsz}}</span></el-menu-item>
                    </el-submenu>
                    <el-submenu index="4">
                        <template slot="title"><p @click="showStatus(4)">停工 <span style="color:#36C635;margin-left:10px;">{{num.tg.tgxm}}</span></p></template>
                        <el-menu-item index="4-1" class="total-item">房建 <span style="color:#FFBC01;margin-left:10px;">{{num.tg.tgfj}}</span></el-menu-item>
                        <el-menu-item index="4-2" class="total-item">市政 <span style="color:#FFBC01;margin-left:10px;">{{num.tg.tgsz}}</span></el-menu-item>
                    </el-submenu>
                </el-menu>
            </div>
            <div class="head-search demo-input-suffix" style="background:important;">
                <el-select v-model="search.name" filterable clearable popper-class="fen-sel" class="fen-val" placeholder="选择检索项目"  @change="doFilter">
                    <el-option
                    v-for="item in projects"
                    :key="item.id"
                    :label="item.name"
                    :value="item.name">
                    </el-option>
                </el-select>
            </div>
        </div>
        <div class="box-table">
            <div class="box-table-item" v-for="item in listData" :key="item.id">
                <div style="width:80px;">{{item.index}}</div>
                <div style="width:100px;">{{item.projectType=='1'?'房建':'市政'}}</div>
                <div style="width:300px;" class="nowrap" :title="item.name">{{item.name}}</div>
                <div style="width:200px;text-align: right;">总工期：{{item.allDay}}天</div>
                <div style="flex:1;padding:0 20px;" class="progress1">
                    <el-progress :text-inside="true" :stroke-width="36" :percentage="item.progress" color="#2740e6"></el-progress>
                </div>
                <div style="width:200px;text-align: right;color:#36C635;">投资进度</div>
                <div style="flex:1;padding:0 20px;" class="progress2">
                    <el-progress :text-inside="true" :stroke-width="36" :percentage="item.cumulativeComplete" color="#36C635"></el-progress>
                </div>
                <div style="width:100px;padding-right:30px;text-align: right;" @click="toproject(item)">
                    <i class="el-icon-arrow-right" style="font-size:20px;color:#5f74f9;font-weight: bold;cursor: pointer;"></i>
                </div>
            </div>
        </div>
        <div style="width:100%;">
            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="currentPage"
                :page-sizes="[5, 10, 20, 30, 50]"
                :page-size="pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="totalItems"
                style="padding-top:10px;">
            </el-pagination>
        </div>
    </div>
</template>
<script>
import util from '../../untils/util'
import myHttp from '../../untils/port'
export default {
    data(){
        return{
            groupId:'',
            search:{
                name:'',
                ent:'',
                pageNum:0,
                pageSize:0,
                projectStatus:'', //1拟建，2在建，3竣工，4停建
                projectType:'',   //1房屋建筑工程，2市政公用工程
                joinType:3,
            },
            projects:[],
            listData:[],
            currentPage:1,
            pageSize:10,
            totalItems:0,
            num:{
                all:0,
                jg:{jgfj:0,jgsz:0,jgxm:0},
                zj:{zjfj:0,zjsz:0,zjxm:0},
                tg:{tgfj:0,tjsz:0,tgxm:0},
                sjfj:{fj:0,sj:0}
            }
        }
    },
    mounted(){
        this.groupId = this.$store.state.groupId
        if ('' == this.groupId || undefined == this.groupId) {
            this.groupId = util.session.get('groupId')
        }
        util.session.remove('backPage')
        this.getNum()
        this.getData()
        this.getAll()
    },
    methods:{
        // 搜索数据
        doFilter() {
            this.currentPage = 1
            this.getData()
        },
        handleSizeChange(val) {
            this.pageSize = val
            this.handleCurrentChange(this.currentPage)
        },
        handleCurrentChange(val) {
            this.currentPage = val
            this.currentChangePage();
        },
        // 监控当前页码
        currentChangePage(list) {
            this.getData();
        },
        //获取数据
        getData(){
            var that = this
            this.search.entId = this.groupId
            this.search.pageNum=this.currentPage
            this.search.pageSize=this.pageSize
            myHttp.getProjectPageListByEntIdAndJoinType(this.search).then(function(resp) {
                //console.log(resp)
                if (resp.data.code == '200') {
                    var list = resp.data.data.pageInfo.list || []
                    for(var i=0;i<list.length;i++){
                        list[i].index = ((that.currentPage - 1) * that.pageSize)+(i+1);
                        if(list[i].allDay==0){
                            list[i].progress = 0
                        }else{
                            list[i].progress = ((parseInt(list[i].allDay)-parseInt(list[i].otherDay))/parseInt(list[i].allDay)*100).toFixed(0)
                        }
                        list[i].progress = parseFloat(list[i].progress)
                        list[i].cumulativeComplete = list[i].cumulativeComplete?parseFloat(list[i].cumulativeComplete):0
                    }
                    that.listData = list
                    //if(that.totalItems==0){
                        that.totalItems = resp.data.data.pageInfo.total
                    //}
                }
            })
        },
        //获取所有项目
        getAll(){
            var that = this
            myHttp.getProjectListByEntIdAndJoinType({
                entId:this.groupId,
                joinType:'3'
            }).then(function(resp) {
                if (resp.data.code == '200') {
                    var list = resp.data.data.list || []
                    that.projects = list
                }
            })
        },
        //获取项目统计
        getNum(){
            var that = this
            myHttp.getListEnterpriseAndJoinType({
                entId:this.groupId,
                joinType:'3'
            }).then(function(resp) {
                if (resp.data.code == '200') {
                    that.num = resp.data.data?resp.data.data:that.num
                }
            })
        },
        //跳转详情
        toproject(row){
            util.session.set('proId', row.id)
            util.session.set('backPage', '2')
            var that = this
            setTimeout(function() {
                that.$router.push({ path: '/entProInfo' })
            }, 0)
        },
        //统计菜单激活回调
        selectFun(index,path){
            // console.log(index,path)
            if(index=='1-1'){
                this.search.projectStatus = ''
                this.search.projectType = '1'
            }else if(index=='1-2'){
                this.search.projectStatus = ''
                this.search.projectType = '2'
            }else if(index=='2-1'){
                this.search.projectStatus = '2'
                this.search.projectType = '1'
            }else if(index=='2-2'){
                this.search.projectStatus = '2'
                this.search.projectType = '2'
            }else if(index=='3-1'){
                this.search.projectStatus = '3'
                this.search.projectType = '1'
            }else if(index=='3-2'){
                this.search.projectStatus = '3'
                this.search.projectType = '2'
            }else if(index=='4-1'){
                this.search.projectStatus = '4'
                this.search.projectType = '1'
            }else if(index=='4-2'){
                this.search.projectStatus = '4'
                this.search.projectType = '2'
            }
            this.currentPage = 1
            this.getData()
        },
        showStatus(index){
            this.search.projectStatus = index
            this.search.projectType = ''
            this.currentPage = 1
            this.getData()
        },
    },
}
</script>
<style scoped>
    *{
        box-sizing: border-box;
    }
    .nowrap {
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
    }
    .box{
        width:100%;
        position: relative;
        height: 100%;
        background: #010D27;
    }
    .box-head{
        width: 100%;
        height: 40px;
        position: relative;
        display: flex;
        padding: 0 20px;
        background: #001498;
    }
    .head-name{
        display: flex;
        align-items: center;
        color: #AECFDC;
        font-size: 18px;
    }
    .head-num{
        flex: 1;
        padding: 0 20px;
        display: flex;
        align-items: center;
    }
    .head-search{
        width: 240px;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .box .el-submenu{
       margin-right: 20px; 
    }
    .box-table{
        width: 100%;
        height: calc( 100% - 90px );
        position: relative;
        overflow: auto;
    }
    .box-table-item{
        width: 100%;
        height: 100px;
        margin-top: 15px;
        margin-bottom: 15px;
        background: #031260;
        display: flex;
        align-items: center;
        color: #AECFDC;
        box-sizing: border-box;
        font-size: 18px;
    }
    .ptoTotal p{
        margin: 0;
    }
    
</style>
<style>
    .head-num .el-menu--horizontal{
        background: transparent;
        border-bottom:0;
    }
    .head-num .el-menu--horizontal>.el-submenu .el-submenu__title{
        height: 40px;
        line-height: 40px;
        border-bottom: 0;
        color: #AECFDC;
        background: transparent;
        font-size: 18px;
    }
    .head-num .el-menu--horizontal>.el-submenu .el-submenu__icon-arrow{
        display: none;
    }
    .el-menu--horizontal .total-item{
        background-color: rgb(0, 20, 152);
        font-size: 16px;
        color: #ffffff !important;
    }
    .progress1 .el-progress-bar__outer{
        background-color:#001498
    }
    .progress2 .el-progress-bar__outer{
        background-color:#4D7BF4
    }
    .fen-val .el-input__inner{
        background: transparent;
        border: 0;
        font-size: 16px;
        text-align: right;
        color: #fff;
    }
    .fen-sel,.fen-sel .el-select-dropdown__item.hover,.fen-sel .el-select-dropdown__item:hover{
        background: #001498;
        border: 0;
    }
    .fen-sel .el-select-dropdown__empty,.fen-sel .el-select-dropdown__item{
        color: #fff;
    }
    .fen-val.el-select .el-input{
        width: 240px;
    }
    .ptoTotal .el-pagination span{
        color: white;
    }
    .ptoTotal .el-pagination .el-input__inner{
        background: transparent;
        color: white;
    }
    .ptoTotal .el-menu--horizontal{
        box-shadow: none;
    }
    .ptoTotal .el-pagination{
        background: inherit ;
    }
</style>